export default __webpack_public_path__ + "static/media/tailwind.46d61abb.png";